import { render, staticRenderFns } from "./SampleNameRenderer.vue?vue&type=template&id=77f90712&"
import script from "./SampleNameRenderer.vue?vue&type=script&lang=ts&"
export * from "./SampleNameRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./SampleNameRenderer.vue?vue&type=style&index=0&id=77f90712&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports